import { StyledLogo } from "./styles";

function Logo() {
    return ( 
        <StyledLogo>{"> "}brunoPassos</StyledLogo>
     );
}

export default Logo;